function Iceland({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_521_1364)">
        <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
        <path d="M0.551147 20.1738C1.4769 23.6088 3.51721 26.5859 6.26084 28.694V20.1738H0.551147Z" fill="#0052B4"/>
        <path d="M14.6086 31.939C15.0673 31.9785 15.5311 31.9999 16 31.9999C23.3924 31.9999 29.6128 26.9861 31.4488 20.1738H14.6086V31.939Z" fill="#0052B4"/>
        <path d="M31.4488 11.8261C29.6128 5.01381 23.3924 0 16 0C15.5311 0 15.0673 0.021375 14.6086 0.060875V11.8261H31.4488Z" fill="#0052B4"/>
        <path d="M6.26084 3.30615C3.51721 5.41428 1.4769 8.39134 0.551147 11.8263H6.26084V3.30615Z" fill="#0052B4"/>
        <path d="M31.8646 13.9131H12.5218H12.5218V0.380371C11.0431 0.708246 9.64131 1.23968 8.34781 1.9455V13.9131H0.135438C0.046375 14.5962 0 15.2927 0 16.0001C0 16.7074 0.046375 17.4039 0.135438 18.087H8.34775H8.34781V30.0546C9.64131 30.7603 11.0431 31.2919 12.5218 31.6197V18.0872V18.0871H31.8646C31.9535 17.4039 32 16.7074 32 16.0001C32 15.2927 31.9535 14.5962 31.8646 13.9131Z" fill="#D80027"/>
      </g>
    </svg>
  `;

  return baseXml;
}

export default Iceland;
